import { IconButton } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './JobNavigation.css';

class JobNavigation extends Component {
  goNext = e => {
    e.stopPropagation();
    const { page, onClick } = this.props;
    if (onClick) onClick((page || 1) + 1);
  }

  goBack = e => {
    e.stopPropagation();
    const { page, onClick } = this.props;
    if (onClick) onClick((page || 1) - 1);
  }

  render () {
    const { total, page, loading } = this.props;
    const totalPages = Math.ceil(total / 4);
    return (
      <div className="JobNavigation">
        <div className="JobNavigation-content">
          {this.props.children}
        </div>
        {totalPages > 1 ? (
          <div>
            <IconButton disabled={loading || (page || 1) <= 1} onClick={this.goBack}><ChevronLeftIcon fontSize="large"/></IconButton>
            <IconButton disabled={loading || (page || 1) >= totalPages} onClick={this.goNext}><ChevronRightIcon fontSize="large"/></IconButton>
          </div>
        ) : null}
      </div>
    );
  }
}

JobNavigation.propTypes = {
  total: PropTypes.number,
  page: PropTypes.number,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any
};

export default JobNavigation;
